module.exports = "/images/ce.svg?4e25838304576347b01ebe42879353dd";